import React, {useContext} from 'react'
import {Avatar} from '@components/common/base/avatar'
import {Dropdown} from '@components/common/dropdown/dropdown'
import {IconTabler} from '@components/common/icon-tabler/icon-tabler'
import {
  TwArrow,
  TwAvatar,
  TwChildren,
  TwDot,
  TwIcon,
  TwLabel,
  TwSelect,
  TwWrap
} from './containers'
import IconArrow from './icon-arrow.svg'
import IconDot from './icon-dot.svg'
import {SelectProps} from './types'

const PropsContext = React.createContext(undefined as unknown as SelectProps)

export const Select = (props: SelectProps) => {
  return (
    <PropsContext.Provider value={props}>
      <SelectBase />
    </PropsContext.Provider>
  )
}

export const SelectBase = () => {
  const props = useContext(PropsContext)
  const {label, disabled = false, labelStyle, bgColor} = props
  if (label) {
    return (
      <TwWrap>
        <TwLabel style={labelStyle} $disabled={disabled} $bgColor={bgColor}>
          {label}
        </TwLabel>
        <SelectComponent />
      </TwWrap>
    )
  }
  return <SelectComponent />
}

export const SelectComponent = () => {
  const props = useContext(PropsContext)
  const {
    onOpenChange,
    open,
    content,
    disabled = false,
    dot = false,
    size,
    className,
    children,
    placeholder,
    link = false,
    variant = 'default',
    placement,
    error = false,
    selectStyle,
    truncate = true,
    bgColor
  } = props

  const change = () => {
    if (disabled) {
      return
    }
    onOpenChange(true)
  }

  return (
    <Dropdown
      hideArrow
      placement={placement}
      onVisibleChange={() => onOpenChange(false)}
      visible={open}
      duration={0}
      content={content}
    >
      <TwSelect
        onClick={change}
        $disabled={disabled}
        $active={open}
        $placeholder={Boolean(!children && placeholder)}
        $size={size}
        className={className}
        $link={link}
        $variant={variant}
        $bgColor={bgColor}
        $error={error}
        style={selectStyle}
      >
        {dot && <Dot />}
        <Icon />
        <AvatarIcon />
        <TwChildren $truncate={truncate}>{children ?? placeholder}</TwChildren>
        <TwArrow
          $variant={variant}
          $link={link}
          $rotate={open}
          $disabled={disabled}
        >
          <IconArrow />
        </TwArrow>
      </TwSelect>
    </Dropdown>
  )
}

const Dot = () => (
  <TwDot>
    <IconDot />
  </TwDot>
)

const AvatarIcon = () => {
  const props = useContext(PropsContext)
  const {avatar} = props
  if (!avatar) {
    return null
  }
  return (
    <TwAvatar>
      <Avatar userId={avatar} hideStatus hideOutline size={16} />
    </TwAvatar>
  )
}

const Icon = () => {
  const props = useContext(PropsContext)
  const {icon} = props
  if (!icon) {
    return null
  }
  return (
    <TwIcon>
      <IconTabler
        customSize={16}
        icon={icon}
        viewBox="0 0 24 24"
        type="navigation"
      />
    </TwIcon>
  )
}
